document.addEventListener('DOMContentLoaded', () => {
    document
        .querySelectorAll('[data-module="./formFileUpload"]')
        .forEach(element => {
            initFormDragAndDrop(element);
        });
});

function initFormDragAndDrop(element) {
    var els = element.querySelectorAll('.form__draganddrop');

    var maxEmailSize = 15728640;

    Array.prototype.forEach.call(els, el => {
        var uploadingFiles = 0;
        var allFiles = [];
        var fileInput = el.querySelector('input[type="file"]');
        var allFilesInput = el.querySelector('input[type="text"]');
        allFilesInput.value = '';

        var formAddress = '/file/';
        var uploadAddress = formAddress + 'UploadFile';
        var deleteAddress = formAddress + 'DeleteFile';

        var deleteFile;

        var updateGeneralError = function (size) {
            var element = el.querySelector('.form__draganddrop-generalerror');
            var form = el.closest('form');
            var button = form.querySelector('button[type=submit]');

            if (size >= maxEmailSize) {
                element.classList.remove('form__draganddrop-generalerror-hidden');

                if (allFiles.length > 0) {
                    button.disabled = true;
                }
            } else {
                element.classList.add('form__draganddrop-generalerror-hidden');
                button.disabled = false;
            }
        }

        var updateFiles = function () {
            var parent = el.querySelector('.form__draganddrop-files');
            if (allFiles.length > 0)
                allFilesInput.value = JSON.stringify(allFiles);
            else
                allFilesInput.value = '';

            Array.prototype.forEach.call(parent.querySelectorAll('div[data-guid]'), el => {
                var found = false;
                var guid = el.getAttribute('data-guid');
                allFiles.forEach(file => { found |= file.guid === guid; });
                if (!found)
                    parent.removeChild(el);
            });

            allFiles.forEach(file => {
                if (parent.querySelector('div[data-guid="' + file.guid + '"]') !== null)
                    return;

                var div = document.createElement('div');
                div.classList.add('form__draganddrop-file');

                var remove = document.createElement('div');
                remove.classList.add('form__draganddrop-remove');
                remove.addEventListener('click', () => {
                    deleteFile(file);
                });
                div.append(remove);

                div.setAttribute('data-guid', file.guid);
                div.append(file.filename);
                parent.append(div);
            });

            var size = 0;
            allFiles.forEach(file => {
                size += file.size;
            });
            updateGeneralError(size);
        };

        var addUploadError = function (file, messageClass) {
            var parent = el.querySelector('.form__draganddrop-errors');
            var div = document.createElement('div');
            div.classList.add('form__draganddrop-error');
            div.innerText = file.name + ' - ' + fileInput.form.querySelector(messageClass).innerText;
            parent.insertBefore(div, parent.firstChild);
        }

        var clearUploadErrors = function () {
            var parent = el.querySelector('.form__draganddrop-errors');
            while (parent.lastElementChild) {
                parent.removeChild(parent.lastElementChild);
            }
        }

        var uploadFile = function (file, callback) {
            var formData = new FormData();
            formData.set('__RequestVerificationToken', fileInput.form.querySelector('input[name="__RequestVerificationToken"]').value);
            formData.set('file', file);

            var xhr = new XMLHttpRequest();
            xhr.onreadystatechange = function () {
                if (xhr.readyState === 4) {
                    if (xhr.status === 200) {
                        var response = JSON.parse(xhr.responseText);
                        if (response.result === 1) {
                            allFiles.push.apply(allFiles, response.files);
                            updateFiles();
                        }
                    } else
                        if (xhr.status === 413) {
                            addUploadError(file, '.form__draganddrop-maxsize');
                        } else {
                            if (xhr.responseText.includes('Maximum request length exceeded')) { //Somtimes returns 500 status when request length is to large
                                addUploadError(file, '.form__draganddrop-maxsize');
                            } else {
                                addUploadError(file, '.form__draganddrop-other');
                            }
                        }
                    callback();
                }
            }
            xhr.open('POST', uploadAddress, true);
            xhr.send(formData);
        }

        var uploadFiles = function (files) {
            if (files.length === 0)
                return;

            if (uploadingFiles === 0)
                el.querySelector('.form__draganddrop-uploading').classList.remove('form__draganddrop-uploading-hidden');
            uploadingFiles++;

            var index = 0;
            clearUploadErrors();
            var callback = function () {
                if (index < files.length) {
                    uploadFile(files[index++], callback);
                } else {
                    uploadingFiles--;
                    if (uploadingFiles === 0) {
                        el.querySelector('.form__draganddrop-uploading').classList.add('form__draganddrop-uploading-hidden');
                    }
                }
            }
            callback();
        }

        deleteFile = function (file) {
            var formData = new FormData();
            formData.set('__RequestVerificationToken', fileInput.form.querySelector('input[name="__RequestVerificationToken"]').value);
            formData.set('Guid', file.guid);
            var xhr = new XMLHttpRequest();
            xhr.open('POST', deleteAddress, true);
            xhr.send(formData);

            var index = -1;
            allFiles.forEach((f, i) => { if (f.guid === file.guid) index = i; });
            if (index !== -1)
                allFiles.splice(index, 1);
            updateFiles();
        }

        fileInput.addEventListener('change', e => {
            uploadFiles(e.target.files);
        });
        el.addEventListener('dragenter', e => {
            e.preventDefault();
            e.stopPropagation();
        });
        el.addEventListener('dragleave', e => {
            e.preventDefault();
            e.stopPropagation();
        });
        el.addEventListener('dragover', e => {
            e.preventDefault();
            e.stopPropagation();
        });
        el.addEventListener('drop', e => {
            e.preventDefault();
            e.stopPropagation();
            uploadFiles(e.dataTransfer.files);
        });
    });
}